import { type Component } from "solid-js";
import { normalizeRole, type Role } from "../../lib/rbac";

interface RoleBadgeProps {
  role?: string;
  size?: "sm" | "md";
}

export const RoleBadge: Component<RoleBadgeProps> = (props) => {
  const role = (): Role => normalizeRole(props.role);

  const styleConfig = () => {
    switch (role()) {
      case "owner":
        return "bg-amber-950/40 text-amber-300 border-amber-500/50";
      case "admin":
        return "bg-forge/15 text-forge-hi border-forge/50";
      case "maintainer":
        return "bg-cyan-950/40 text-phos border-phos/50";
      case "member":
        return "bg-emerald-950/40 text-verdict-ok border-emerald-500/50";
      case "viewer":
      default:
        return "bg-iron-2 text-ink-dim border-seam";
    }
  };

  const label = () => {
    const r = role();
    return r.charAt(0).toUpperCase() + r.slice(1);
  };

  const isSmall = () => props.size === "sm";

  return (
    <span
      class={`inline-flex items-center gap-1 rounded font-disp uppercase tracking-wider font-semibold border ${styleConfig()} ${
        isSmall() ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]"
      }`}
    >
      <span class="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      {label()}
    </span>
  );
};
